<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :server-items-length="totalRows"
        :items="tableItems"
        :loading="loading"
        :loading-text="$t('keywords.loading')"
        class="elevation-1"
        :items-per-page.sync="_itemsPerPage_"
        :page.sync="_page_"
        :footer-props="footerProps"
        @update:page="findTableData"
        @update:items-per-page="findTableData"
      >
        <template #top>
          <v-toolbar flat color="white">
            <v-toolbar-title v-text="$t('monitoring.executions')" />
            <v-spacer />
            <RefreshButton @click="$emit('refresh')" />
          </v-toolbar>
        </template>

        <template #item.logIdentifier="{ item }">
          <v-btn @click="showLog(item.logIdentifier)" v-text="item.logIdentifier" v-if="item.logIdentifier" />
        </template>

        <template #item.status="{ item }">
          <v-icon class="mr-2" :color="Utils.getIconColor(item.status)" v-html="Utils.getIcon(item.status)" />
        </template>

        <template #no-data v-text="$t('warnings.no_data_found')" />

      </v-data-table>
    </v-col>
  </v-row>
</template>
<script>
import Utils from '../../utils'
import RefreshButton from '../RefreshButton.vue'

export default {
  name: 'DataTable',
  data: () => ({
    Utils,
    footerProps: {
      itemsPerPageOptions: [5, 10, 15, 20]
    }
  }),
  computed: {
    _page_: {
      get () { return this.page + 1 },
      set (v) { this.$emit('update:page', v - 1) }
    },
    _itemsPerPage_: {
      get () { return this.itemsPerPage },
      set (v) { this.$emit('update:items-per-page', v) }
    },
    tableItems () {
      return Utils.fillPagination(this.items, this._itemsPerPage_)
    },
    headers () {
      return [
        {
          text: this.$t('keywords.id'),
          value: 'logIdentifier',
          sortable: false,
          align: 'start'
        },
        {
          text: this.$t('monitoring.execution_date'),
          value: 'currentDate',
          sortable: false,
          align: 'center'
        },
        {
          text: this.$t('monitoring.status'),
          value: 'status',
          sortable: false,
          align: 'start'
        }
      ]
    }
  },
  props: {
    itemsPerPage: Number,
    page: Number,
    totalRows: Number,
    items: Array,
    loading: Boolean
  },
  methods: {
    findTableData () { this.$emit('findTableData') },
    showLog (id) {
      const query = { ...this.$route.query, id }
      this.$router.push({ path: 'monitoring-legacy/process-log', query })
    }
  },
  components: { RefreshButton }
}
</script>
